import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sisesta siia otsisõna...

  <span style="color:#85c1dc;">**FI:**</span>
  Kirjoita hakusana tähän...

  <span style="color:#85c1dc;">**RU:**</span>
  Введите слово для поиска здесь...
*/
/* @__NO_SIDE_EFFECTS__ */
const m708 = msg(
  mf`Sisesta siia otsisõna...`,
  mf`Kirjoita hakusana tähän...`,
  mf`Введите слово для поиска здесь...`,
)

export { m708 as 'w.module.categories_search.placeholder_short' }